import { Component, Input, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonContent } from '@ionic/angular/standalone';

import { ButtonComponent } from 'src/app/atoms/button/button.component';
import { HelperModalControllerService } from 'src/app/helpers/helper-modal-controller.service';
import { HelperBuildUpdateControllerService, BuildUpdateStatus } from 'src/app/helpers/helper-build-update-controller.service';

@Component({
  selector: 'app-modal-build-update',
  templateUrl: './build-update.component.html',
  styleUrls: ['./build-update.component.scss'],
  standalone: true,
  imports: [CommonModule, IonContent, ButtonComponent],
})
export class ModalBuildUpdateComponent {
  @Input() mode: BuildUpdateStatus = 'FORCE_UPDATE';
  @Input() title?: string;
  @Input() message?: string;
  @Input() currentVersion = '1.0.0';
  @Input() targetVersion = '1.0.0';
  @Input() storeUrls?: { android?: string; ios?: string };

  private helperModalControllerService = inject(HelperModalControllerService);
  private updateControllerService = inject(HelperBuildUpdateControllerService);

  get isForce(): boolean {
    return this.mode === 'FORCE_UPDATE';
  }

  get isMaintenance(): boolean {
    return this.mode === 'MAINTENANCE';
  }

  get isOptional(): boolean {
    return this.mode === 'OPTIONAL_UPDATE';
  }

  get displayTitle(): string {
    if (this.title) return this.title;
    if (this.isMaintenance) return 'System Maintenance';
    if (this.isForce) return 'Update Required';
    return 'New Update Available';
  }

  get displayMessage(): string {
    if (this.message) return this.message;
    if (this.isMaintenance) {
      return 'We are performing scheduled system upgrades. Please check back in a few minutes.';
    }
    if (this.isForce) {
      return 'This version of the app is no longer supported. Please update to the latest version to continue using BM.';
    }
    return 'A newer version of the app is available with performance improvements and bug fixes.';
  }

  get heroIcon(): string {
    if (this.isMaintenance) return 'engineering';
    if (this.isForce) return 'system_update';
    return 'upgrade';
  }

  actionUpdate(): void {
    this.updateControllerService.openStoreUrl(this.storeUrls);
  }

  async actionRetry(): Promise<void> {
    await this.updateControllerService.checkUpdate();
  }

  actionLater(): void {
    if (this.isOptional) {
      this.helperModalControllerService.dismiss({}, 'cancel');
    }
  }
}
